import { initFlyout } from '../../components/flyoutUnderHeader';

const SELECTORS = {
  CONTAINER: '.product-detail__delivery__pane',
};

export default () => {
  const deliveryContainer = document.querySelector(SELECTORS.CONTAINER);

  if (deliveryContainer) {
    initFlyout(deliveryContainer);
  }
};
